import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const contextDefinitionsSlice = createCrudSlice({
  name: 'contextDefinitions',
})

export const ContextDefinitionsActions = contextDefinitionsSlice.actions

export const ContextDefinitionsSelectors = {
  ...createCrudSelectors({ name: 'contextDefinitions' }),
}

export default contextDefinitionsSlice.reducer